import { ChangeDetectorRef, Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingService } from './loading.service';

@Component({
    selector: 'nuc-loading',
    imports: [MatProgressSpinnerModule],
    templateUrl: './loading.component.html',
    styleUrl: './loading.component.scss'
})
export class LoadingComponent {
  loading: boolean = false;
  constructor(private loadingService: LoadingService,private cdr: ChangeDetectorRef) { }

  ngOnInit(): any {
    this.loadingService.loading$.subscribe((loading) => {
      this.loading = loading;
      this.cdr.detectChanges();
    });
  }
}
